import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { AppStateLogin } from "../redux/auth";
import { IAppState } from "../redux/types";
import { RoleType } from "../redux/users";
import { StorageHelper } from "../utils/StorageHelper";
import { history } from "./BrowserHistory";
interface IProtectedRouteProps extends RouteProps {
  isAuthorized: boolean;
  isLoading?: boolean;
  name?: string;
}

const ProtectedRoute: React.Factory<IProtectedRouteProps> = (
  props: IProtectedRouteProps
) => {
  const { children, ...newProps } = props;
  const { isAuthenticated } = useSelector<IAppState, AppStateLogin>(
    (state) => state.auth
  );

  const shouldDisplayOrgPageDef = false;
  useEffect(() => {
    if (
      isAuthenticated &&
      shouldDisplayOrgPageDef &&
      history.location.pathname === "/monitor"
    ) {
      // console.log('replace');
      history.push("/settings/organization");
    }
  }, [isAuthenticated, shouldDisplayOrgPageDef]);

  return isAuthenticated ? (
    <Route {...props} />
  ) : (
    <>
      <Route
        {...newProps}
        component={() => <Redirect to="/login" />}
        render={undefined}
      />
    </>
  );
};

const PublicRoute: React.Factory<IProtectedRouteProps> = (
  props: IProtectedRouteProps
) => {
  const { isAuthorized, isLoading, children, name, ...newProps } = props;
  // console.log('publicRoute ', isAuthorized, name ? name : '');
  // if (isLoading) return null;
  // if (isSigningIn && isAuthorized && name === 'startView') return <Route {...props} />;
  const { isAuthenticated } = useSelector<IAppState, AppStateLogin>(
    (state) => state.auth
  );
  return !isAuthenticated ? (
    <Route {...props} />
  ) : (
    <Route
      {...newProps}
      component={() => <Redirect to="/" />}
      render={undefined}
    />
  );
};

const SavedRoute: React.Factory<RouteProps> = (props: RouteProps) => {
  const { roleName, id } = useSelector((state: IAppState) => state.userProfile);
  if (roleName === RoleType.CAREGIVER || roleName === RoleType.DISPLAY) {
    const { path, ...rest } = props;
    if (path.indexOf("/monitor") !== -1) {
      StorageHelper.instance.SavePage(String(props?.path), id);
      return <Route {...props} />;
    }
    return <Route path={"/monitor"} {...rest} />;
  }
  StorageHelper.instance.SavePage(String(props?.path), id);

  return <Route {...props} />;
};
export { ProtectedRoute, PublicRoute, SavedRoute };
